function roundHumanCount(value) {
  const match = value.match(/^([\d.]+)([KkMmBb]?)$/)
  if (!match) return value

  const [, numStr, unit] = match
  const upperUnit = unit.toUpperCase()
  if (upperUnit !== 'K') return value

  const num = parseFloat(numStr)

  if (num >= 10) {
    const rounded = Math.floor(num / 10) * 10
    return `${rounded}K`
  }

  return `${Math.floor(num)}K`
}

export default roundHumanCount
